var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShareWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.998 6.628a3.15 3.15 0 10-3.126-2.761L5.685 6.46a3.15 3.15 0 100 4.535l5.187 2.594a3.15 3.15 0 10.94-1.879L6.625 9.117a3.18 3.18 0 000-.777l5.187-2.594a3.135 3.135 0 002.186.882z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShareWhite);
export default __webpack_public_path__ + "static/media/icon-share-white.6643d1bb61af2f7ced93f053690d185f.svg";
export { ForwardRef as ReactComponent };